import React from 'react';
import styled from 'styled-components';

const Spinner = styled.svg`
  animation: rotate 1s linear infinite;
  width: 20px;
  height: 20px;
  margin-right: 1rem;

  & .path {
    stroke: ${props => props.theme.carvana.grayOne};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

const LoadingSpinner = () => (
  <Spinner viewBox="0 0 50 50">
    <circle
      className="path"
      cx="25"
      cy="25"
      r="20"
      fill="none"
      strokeWidth="3"
    />
  </Spinner>
);

export default LoadingSpinner;
